import { reactive } from 'vue';
import { lang } from './myapp/src/lang';
import { tools } from './myapp/src/tools/toolList';

const EventEmitter = require('events');

export const store = {
    install: (app, options) => {

        const getInitialState = () => ({
            startedApp: false,
            swatches: [],
            loggedIn: loggedIn,
            plasticMode: false,
            libraryShape: 'cylinder',
            currentScreen: 'splash-dialog',
            defaultPaletteID: null,
            showLoadingErrorMessage: false,
            showingModal: null,
            showingTour: false,
            coordinates: '',
            showCoordinates: true,
            colorMatch: false,
            dialogBox: {
                visible: false,
                showTextInput: false,
                textInputValue: '',
                title: ''
            },
            infoBox: {
                visible: false,
                message: '',
                warning: false
            },
            bakeImageModal: {
                bakePaletteSize: '15',
                bakeMethod: 'RGB',
                limitBake: false
            },
            beadSoupActive: false,
            currentTab: null,
            hasBooted: false,
            upgradeLog: [],
            beadsToShow: [],
            browserResults: [],
            browserResultCount: 0,
            browserQueryCache: {}, // maps queries to lists of project ids
            browserResultCache: {}, // stores the query results from cached queries
            browserQueryCountCache: {}, // stores the number of results from cached queries
            projectCount: 0,
            currentMode: '',
            tools,
            showingPanel: null,
            openFile: {},
            tags: [],
            projects: [],
            collections: [],
            customBeads: [],
            templates: [],
            userImageFileName: ''
        });

        app.config.globalProperties.store = {
            debug: false,
            state: reactive(getInitialState()),
            mySet(key, value) {
                if (this.debug) {
                    console.info(`Set ${key} to ${value}`);
                }
                if (key.includes('.')) {
                    const keyPath = key.split('.');
                    this.state[keyPath[0]][keyPath[1]] = value;
                } else {
                    this.state[key] = value;
                }
            }
        };

        b3.store = app.config.globalProperties.store;

        app.config.globalProperties.t = lang.get;

        app.config.globalProperties.ee = new EventEmitter();

        b3.ee = app.config.globalProperties.ee;
    }
};